import * as React from 'react';

import { UserContext } from '../providers/UserProvider';
import PickupDispensarySection from './PickupDispensarySection';
import Spinner from '../common/Spinner';

import styles from '../dispensaries/Dispensaries.module.css';

const PickupDispensariesList = () => {
 
  const { setSearchLocation } = React.useContext(UserContext);
  
  // content fades in on render
  const fader = React.createRef();
  const loading = false; // some loading state
  const wrapClass = loading ? styles.fadeWrapper : `${styles.fadeWrapper} ${styles.fadeIn}`;
  
  return ( !!setSearchLocation
    ? <div className={wrapClass} ref={fader}>
        <PickupDispensarySection 
          setSearchLocation={setSearchLocation} /> 
      </div>
    : <Spinner />  
  )
}

export default PickupDispensariesList;